<template>
  <div class="main-view book-a-demo-container">
		<div class="bg-container book-a-demo-hero ">
			<h1>Book your personal Evergrow tour</h1>
			<bg-wave-element></bg-wave-element>
		</div>
		<section class="contact-section-container">
			<div class="flex-container column flex-row" id="join-now-href">
				<p>The best way to evaluate Evergrow is to experience it for yourself with a personal tour. Just complete the form below and we’ll contact you shortly to arrange a convenient{{'\xa0'}}time.</p>
				<BookADemoForm />
			</div>
			<div class="staff-bubbles">
				<img class="staff-img one" src="@/assets/img/staff/staff-1.png" alt="" data-aos="zoom-in">
				<img class="staff-img two" src="@/assets/img/staff/staff-2.png" alt="" data-aos="zoom-in" data-aos-delay="100">
				<img class="staff-img three" src="@/assets/img/staff/staff-3.png" alt="" data-aos="zoom-in" data-aos-delay="500">
				<img class="staff-img four" src="@/assets/img/staff/staff-4.png" alt="" data-aos="zoom-in" data-aos-delay="500">
				<img class="staff-img five" src="@/assets/img/staff/staff-5.png" alt="" data-aos="zoom-in" data-aos-delay="500">
				<img class="staff-img six" src="@/assets/img/staff/staff-6.png" alt="" data-aos="zoom-in" data-aos-delay="200">
				<img class="staff-img seven" src="@/assets/img/staff/staff-7.png" alt="" data-aos="zoom-in" data-aos-delay="500">
				<img class="staff-img eight" src="@/assets/img/staff/staff-8.png" alt="" data-aos="zoom-in" data-aos-delay="300">
				<img class="staff-img nine" src="@/assets/img/staff/staff-9.png" alt="" data-aos="zoom-in" data-aos-delay="500">
			</div>
		</section>
		<Demo />
	</div>
</template>

<script>
	import Demo from '@/components/Demo.vue'
	import BookADemoForm from '@/components/BookADemoForm.vue'

	export default {
		components: {
			Demo,
			BookADemoForm
		}
	}
</script>

<style lang="stylus">
	.book-a-demo-container 
		margin-top 117px

	.book-a-demo-hero
		// background linear-gradient(to right, rgba(0, 165, 98, 0.5), rgba(0, 165, 98, 0.5)), url('~@/assets/img/bgs/book-a-demo.jpg') center bottom / 100% no-repeat #00A562
		background url('~@/assets/img/bgs/book-a-demo-hero.jpg') center bottom / cover no-repeat #00A562
		padding 120px 0 280px
		position relative
		
		h1 
			color white
			font-size 85px
			text-align  center
	

	.book-a-demo-container section.demo-inner, 
	.book-a-demo-container .demo-container svg
		display none 

	.flex-container 
		width 90%
		margin 0 auto
		align-items: center

	.flex-container.column { flex-direction: column }


	.contact-section-container {
		background-color: #00A562;
		height: auto;
		width: 100%;
		position: relative;
		// margin-top -130px
		// background url('~@/assets/img/bgs/book-contact-top.png') center top / 100% no-repeat transparent
	}

	.contact-section-container .flex-container {
		width: 100%;
		position: relative;
		z-index: 100;
	}
	.contact-section-container h2 {
		font-size: 50px;
		color: #fff;
		text-align: center;
		margin: 80px 0 20px;
	}
	.contact-section-container p {
		width: 35%;
		margin-bottom: 60px;
		color: #fff;
		text-align: center;
		padding-top: 150px;
		font-weight: 300;
		padding: 20px 0;
	}

	.contact-section-container .staff-bubbles img.staff-img 
		width: 113px
		height: 113px
		position: absolute
		box-shadow: 0px 20px 40px #00000033
		border-radius: 100%
		// opacity: 0;

	.contact-section-container .staff-bubbles img.one {
		left: 16%;
		top: -2%;
	}
	.contact-section-container .staff-bubbles img.two {
		left: 5%;
		top: 12%;
	}
	.contact-section-container .staff-bubbles img.three {
		left: 19%;
		top: 18%;
	}
	.contact-section-container .staff-bubbles img.four {
		left: 13%;
		top: 32%;
	}
	.contact-section-container .staff-bubbles img.five {
		left: 8%;
		top: 51%;
	}
	.contact-section-container .staff-bubbles img.six {
		right: 4%;
		top: -4%;
	}
	.contact-section-container .staff-bubbles img.seven {
		right: 14%;
		top: 11%;
	}
	.contact-section-container .staff-bubbles img.eight {
		right: 9%;
		top: 26%;
	}
	.contact-section-container .staff-bubbles img.nine {
		right: 18%;
		top: 40%;
	}
	

	@media ( max-width: 1000px ) 	
		.book-a-demo-container
			margin-top 90px
			
		.book-a-demo-hero 
			padding 80px 20px 60px
			
			h1
				font-size 56px	
			
			svg
				display none
				
		.video-section 
			padding-bottom 0
			margin-bottom 80px
			
			p
				margin-bottom 0
				padding-bottom 0
				
		.contact-section-container p
			width 80%
			padding 80px 0 0

		.staff-bubbles
			display none
			
		.form-container
			min-width unset	
			width 80%
			padding 30px
</style>